import { useState } from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalFooter, Modal, Button } from 'reactstrap';
import { httpServiceInstanceNode } from '../../services/http/httpService';

const ModalOptions = (props) => {
  const [modalState, setModalState] = useState(true);
  const handleModalState = () => {
    if (modalState === true) {
      setModalState(false);
      props.load(false);
    } else {
      setModalState(true);
    }
  };

  const handleModalAccept = async () => {
    props.load(true);
    setModalState(false);

    try {
      const res = await httpServiceInstanceNode.post(props.url, props.raw);

      if (props.module !== undefined) {
        await props.module();
      }

      if (props.comment !== undefined && props.comment !== '') {
        await props.comment();
      }

      if (props.isAdditio === false || props.isAdditio === undefined) {
        window.location.reload();
      } else {
        props.setNewModal(true);
        props.setHeader(res.respuesta);
      }
    } catch (error) {
      // No hacer nada específico aquí.
    } finally {
      props.load(false);
    }
  };

  return (
    <Modal isOpen={modalState} centered>
      <ModalBody>
        {props.withLoader ? (
          <h4 className="text-center mt-3">Cargando...</h4>
        ) : (
          <h4 className="text-center mt-3">{props.header}</h4>
        )}
      </ModalBody>
      {!props.withLoader && (
        <ModalFooter style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button color={props.color1} onClick={handleModalState}>
            {props.text1}
          </Button>
          <Button
            color={props.color2}
            onClick={props.onAccept ? props.onAccept : handleModalAccept}
          >
            {props.text2}
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};
ModalOptions.propTypes = {
  header: PropTypes.string,
  load: PropTypes.func,
  url: PropTypes.string,
  raw: PropTypes.object,
  text1: PropTypes.string,
  color1: PropTypes.string,
  text2: PropTypes.string,
  color2: PropTypes.string,
  module: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  comment: PropTypes.string,
  isAdditio: PropTypes.bool,
  setNewModal: PropTypes.func,
  setHeader: PropTypes.func,
  onAccept: PropTypes.func,
  withLoader: PropTypes.bool,
};
export default ModalOptions;
